import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { DataService } from '../../../../Services/DataSharingService';
import { Subscription } from 'rxjs/Subscription';
import { HeaderService } from '../../../../Services/HeaderService';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-gradient-diagonal-buttons',
  templateUrl: './gradient-diagonal-buttons.component.html',
  styleUrls: ['./gradient-diagonal-buttons.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class GradientDiagonalButtonsComponent implements OnInit {

	@ViewChild('container', { read: ElementRef }) container: ElementRef;

	private subscription: Subscription[] = [];
	public data: string = '';
	public showCode = '';

	constructor(private _dataService: DataService, private cdRef: ChangeDetectorRef, private _headerService: HeaderService, private _titleService: Title) {
		_titleService.setTitle('Buttons');
        _dataService.GetCode().subscribe(data => {
			this.data = data;
		})
		_dataService.showCode.subscribe(value => {
			this.showCode = value;
		})
	}

	ngOnInit() {
		this._dataService.SetCode(this.container.nativeElement.innerHTML);
	}

	ngOnDestroy(): void {
		this.subscription.map(subscription => {
			subscription.unsubscribe();
		})
	}

	ShowCode(event) {
		this.data = this.container.nativeElement.innerHTML;
		if(this.showCode == 'gradient-diagonal-buttons'){
			this._dataService.setState('');
		}else{
			this._dataService.setState('gradient-diagonal-buttons');
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/features/buttons/gradient-diagonal-buttons/gradient-diagonal-buttons.component.ts